import React from 'react';
import styles from './About.module.css';

const About = () => {
  return (
    <section className='section-about'>
        <h1 className='heading section-about__heading'>About</h1>
      </section>
  )
}

export default About;